import { createFileRoute } from '@tanstack/react-router'
import { Separator } from '@workspace/ui/components/separator'
import { requireRoles } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { CalculatorSidebarNav } from '@/features/budget-calculator/components/calculator-sidebar-nav'
import { QuickCalculator } from '@/features/budget-calculator/components/quick-calculator'

export const Route = createFileRoute(
  '/_authenticated/_organization/budget-calculator/quick'
)({
  beforeLoad: async () =>
    requireRoles(['owner', 'admin', 'support_coordinator', 'team_leader']),
  component: QuickCalculatorPage,
})

function QuickCalculatorPage() {
  return (
    <Main fluid>
      <div className='space-y-0.5'>
        <h1 className='text-2xl font-bold tracking-tight md:text-3xl'>
          Quick Budget Calculator
        </h1>
        <p className='text-muted-foreground'>
          Estimate NDIS support costs or calculate available hours from your
          budget
        </p>
      </div>
      <Separator className='my-4 lg:my-6' />
      <div className='flex flex-1 flex-col space-y-2 overflow-hidden md:space-y-2 lg:flex-row lg:space-y-0 lg:space-x-12'>
        <aside className='top-0 lg:sticky lg:w-1/5'>
          <CalculatorSidebarNav />
        </aside>
        <div className='flex w-full flex-col gap-4 overflow-y-hidden p-1 sm:gap-6'>
          <QuickCalculator />
        </div>
      </div>
    </Main>
  )
}
